import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getComplexPriceRules = async () => {
  const response = await axios.get(`${API_URL}/settings/complex-price-rules`, withAuth());
  return Array.isArray(response?.data?.complexPriceRules)
    ? response.data.complexPriceRules
    : Array.isArray(response?.data?.rules) ? response.data.rules : [];
};

export const createComplexPriceRule = async (payload) =>
  (await axios.post(`${API_URL}/settings/complex-price-rules`, payload, withAuth())).data?.complexPriceRule;

export const updateComplexPriceRule = async (ruleId, payload) =>
  (await axios.put(`${API_URL}/settings/complex-price-rules/${ruleId}`, payload, withAuth())).data?.complexPriceRule;

export const deleteComplexPriceRule = async (ruleId) =>
  (await axios.delete(`${API_URL}/settings/complex-price-rules/${ruleId}`, withAuth())).data;
